// This file is auto-generated by graphql-codegen — do not edit directly.
// See `packages/common/scripts/reporting-operations-plugin.ts`.

import { OperationTypeNode } from 'graphql'

export const reportingOperations: readonly { type: OperationTypeNode; name: string }[] = [
  { type: OperationTypeNode.QUERY, name: 'aggregateBillingForecast' },
  { type: OperationTypeNode.QUERY, name: 'aggregateCashForecast' },
  { type: OperationTypeNode.QUERY, name: 'agingDashboard' },
  { type: OperationTypeNode.QUERY, name: 'billingDashboard' },
  { type: OperationTypeNode.QUERY, name: 'billingLineItemReport' },
  { type: OperationTypeNode.QUERY, name: 'changeOrderReport' },
  { type: OperationTypeNode.QUERY, name: 'costCodeReport' },
  { type: OperationTypeNode.QUERY, name: 'lienWaiverReportByVendorAndProject' },
  { type: OperationTypeNode.QUERY, name: 'overviewDashboard' },
  { type: OperationTypeNode.QUERY, name: 'paginatedAgingDashboard' },
  { type: OperationTypeNode.QUERY, name: 'paginatedBillingDashboard' },
  { type: OperationTypeNode.QUERY, name: 'paginatedCashForecastContracts' },
  { type: OperationTypeNode.QUERY, name: 'projectSnapshotSummary' },
  { type: OperationTypeNode.QUERY, name: 'report' },
  { type: OperationTypeNode.QUERY, name: 'reportDataFields' },
  { type: OperationTypeNode.QUERY, name: 'reports' },
  { type: OperationTypeNode.QUERY, name: 'taxGroupReport' },
  { type: OperationTypeNode.QUERY, name: 'timeToPaymentDashboard' },
  { type: OperationTypeNode.QUERY, name: 'unsignedLienWaiversForVendorReport' },
  { type: OperationTypeNode.QUERY, name: 'unsubmittedSignedLienWaiversForVendorReport' },
  { type: OperationTypeNode.QUERY, name: 'vendorReportOpenAmounts' },
  { type: OperationTypeNode.MUTATION, name: 'createAndRunAdHocReport' },
  { type: OperationTypeNode.MUTATION, name: 'createReport' },
  { type: OperationTypeNode.MUTATION, name: 'deleteReport' },
  { type: OperationTypeNode.MUTATION, name: 'runReport' },
  { type: OperationTypeNode.MUTATION, name: 'updateReport' },
]
